export default __webpack_public_path__ + "static/media/SN.4a27f045.svg";